import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Auth is carried entirely by the httpOnly session cookie (sent via withCredentials).
// Purge any legacy localStorage token left by older app versions — if sent as a Bearer
// header it could override the fresh session cookie and cause spurious "Token expired".
try { localStorage.removeItem("jm_admin_token"); } catch (e) { /* ignore */ }

// Gracefully surface an expired/lost admin session WITHOUT destroying in-progress work.
// We never show the raw backend "Token expired" string; instead we notify the app so it
// can prompt a non-destructive re-login (the open form is preserved and the action retried).
let _sessionExpiredNotified = false;
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    const isAuth = status === 401 && (detail === "Token expired" || detail === "Not authenticated" || detail === "Invalid token");
    if (isAuth) {
      const url = error.config?.url || "";
      // Ignore the initial session probe — that's the normal "logged out" path.
      if (!url.includes("/auth/me") && !url.includes("/auth/login")) {
        if (!_sessionExpiredNotified) {
          _sessionExpiredNotified = true;
          window.dispatchEvent(new CustomEvent("admin-session-expired"));
        }
        // Replace the raw token message with a friendly, user-facing one.
        if (error.response?.data) error.response.data.detail = "Your admin session expired. Please sign in again — your work has been kept.";
      }
    }
    return Promise.reject(error);
  }
);
export const resetSessionExpiredFlag = () => { _sessionExpiredNotified = false; };

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function money(value, currency = "USD") {
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(value || 0);
}

// Render a stored UTC ISO timestamp in US Eastern Time (the business time zone).
export function etTime(iso, withTime = true) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const opts = withTime
      ? { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
          timeZone: "America/New_York", timeZoneName: "short" }
      : { year: "numeric", month: "short", day: "numeric", timeZone: "America/New_York" };
    return new Intl.DateTimeFormat("en-US", opts).format(d);
  } catch {
    return iso;
  }
}

